export const secondResidenceDiscountMessage = {
  id: 'second-residence',
  messageText: 'Promoción: Descuento Segunda Residencia',
}

export const secondResidenceDiscountPackOfferId = '_2PA'
